import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

interface CustomTooltipProps extends TooltipProps {
  //placement?: "bottom" | "top" | "left" | "right"; // Add placement options
  height?: string; // Add height prop
  backgroundColor?: string;
  disabled?: boolean;
}

const CustomTooltip = styled(
  ({
    className,
    placement,
    height,
    backgroundColor,
    disabled,
    title,
    color,
    ...props
  }: CustomTooltipProps) => (
    <Tooltip
      arrow
      title={title}
      placement={placement}
      classes={{ popper: className }}
      disableHoverListener={disabled}
      disableFocusListener={disabled}
      disableTouchListener={disabled}
      {...props}
    />
  ),
)(({ theme, color, backgroundColor }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: backgroundColor ?? theme.palette.primary.light,
    '&:hover': {
      width: 0,
      height: 0,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: backgroundColor ?? theme.palette.primary.light,
    color: color ? color : theme.palette.primary.main,
    marginTop: '5px', // Adjust this value as needed
    minHeight: 50, // Use the height prop or fallback to the default
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '20px',
    paddingRight: '20px',
    textAlign: 'center',
    fontSize: '12px',
    '&:hover': {
      width: 0,
      height: 0,
    },
    boxShadow: '4px 4px 10px 0px  rgba(0, 0, 0, 0.1)', // Box shadow: x, y, blur, color (black with 10% opacity)
  },
  [`&:hover`]: {
    visibility: 'hidden',
  },
}));

export default CustomTooltip;
